import AppService from 'App/legacy/AppService';
import logError from 'Helpers/logError';

const getKey = () => {
	const { client } = AppService.getAccountSelf();
	return `ls.historyLog.excludedTypes-${client.id}-${client.userId}`;
};

const readStored = (): string[] => {
	const stored = localStorage.getItem(getKey());
	if (!stored) {
		return [];
	}

	try {
		const parsed = JSON.parse(stored);
		return Array.isArray(parsed) ? parsed.filter((type): type is string => typeof type === 'string') : [];
	} catch (error) {
		logError(error, 'Could not read the timeline filter from local storage');
		return [];
	}
};

// One preference for every card timeline - switching a type off on a company
// keeps it off on the next company and on contacts too. The pill rows are not
// identical taxonomies though (only companies have signals), so a surface reads
// the types it knows about and leaves the rest of the stored list alone when it
// writes. Otherwise toggling a pill on a contact would drop the company-only
// exclusions the user had made.
export const createExcludedTypesStore = <T extends string>(knownTypes: readonly T[]) => {
	const isKnown = (type: string): type is T => (knownTypes as readonly string[]).includes(type);

	return {
		read: (): T[] => readStored().filter(isKnown),
		write: (excludedTypes: readonly T[]) => {
			const untouched = readStored().filter(type => !isKnown(type));
			localStorage.setItem(getKey(), JSON.stringify([...untouched, ...excludedTypes]));
		}
	};
};
